import { configurationService } from '@/services/api/configuration.service';
import { configurationModel } from '@/models/api/configuration.model';
import { sharedHelper, alertHelper } from '@/utils';
import i18n from '@/i18n';

export const CONFIGURATION_MODULE = 'api/configuration';
export const GET_ALL_CONFIGURATION = 'getAllConfiguration';
export const GET_CONFIGURATION = 'getConfiguration';
export const UPDATE_CONFIGURATION = 'updateConfiguration';
export const UPDATE_CONFIGURATION_STATUS = 'updateConfigurationStatus';

const initialPagination = () => ({
    pageNumber: 1,
    pageSize: 15,
    lastPage: 1,
    tableRowsCounts: 0,
    total: 0
});

export const state = {
    list: { data: [], pagination: initialPagination() },
    details: {},
    status: { list: true, detail: true, save: true },
};

function error(commit, exception) {
    commit('failure');
    alertHelper.alertError({ message: sharedHelper.getErrorMessage(exception), title: i18n.t('message.error') });
}

export const actions = {
    async [GET_ALL_CONFIGURATION]({ commit }, { filter }) {
        commit('requesting', 'list');
        try {
            const result = await configurationService.getAll(filter);
            commit('listSuccess', result);
            return result;
        } catch (exception) {
            error(commit, exception);
            return null;
        }
    },
    async [GET_CONFIGURATION]({ commit }, { uuid }) {
        commit('requesting', 'detail');
        try {
            const result = await configurationService.show(uuid);
            commit('detailSuccess', result);
            return result;
        } catch (exception) {
            error(commit, exception);
            return null;
        }
    },
    async [UPDATE_CONFIGURATION]({ commit, dispatch }, { data, filter }) {
        commit('requesting', 'save');
        try {
            const result = await configurationService.update(data);
            commit('success');
            alertHelper.alertSuccess({ message: i18n.t('message.updateXSuccess', [i18n.t('module.configuration')]) });
            await dispatch(GET_ALL_CONFIGURATION, { filter });
            return result;
        } catch (exception) {
            error(commit, exception);
            return null;
        }
    },
    async [UPDATE_CONFIGURATION_STATUS]({ commit, dispatch }, { uuid, isActive, filter }) {
        commit('requesting', 'save');
        try {
            const result = await configurationService.updateStatus(uuid, isActive);
            commit('success');
            await dispatch(GET_ALL_CONFIGURATION, { filter });
            return result;
        } catch (exception) {
            error(commit, exception);
            return null;
        }
    },
};

export const mutations = {
    requesting(state, type) { state.status[type] = false; },
    listSuccess(state, result) {
        const payload = result?.data;
        const rows = Array.isArray(payload) ? payload : (payload ? [payload] : []);
        state.list.data = rows.map(configurationModel);
        state.list.pagination = result?.pagination
            ? sharedHelper.apiPaginationAdapter(result.pagination)
            : { ...initialPagination(), tableRowsCounts: rows.length, total: rows.length };
        state.status.list = true;
    },
    detailSuccess(state, result) {
        state.details = configurationModel(result?.data || result || {});
        state.status.detail = true;
    },
    success(state) {
        state.status = {
            list: true,
            detail: true,
            save: true
        };
    },
    failure(state) {
        state.status = {
            list: true,
            detail: true,
            save: true
        };
    },
};
